class EntitlerController {
  constructor() {
    this.name = 'entitler';
    this.selectedSchools = [];
    this.selectedCourses = [];
    this.selectedClasses = [];
    this.selectedProducts = [];
    this.selectedResources = [];
    this.selectedAleksMasterTemplate = [],
    this.selectedUsers = [];
    this.allClasses = [];
    this.isProductsUnassignmentSuccessful = false;
    this.isProductsAssignmentSuccessful = false;
    this.isResourcesAutoAssigned = false;
    this.schoolMappingUpdated = false;
    this.schoolList = [];
  }
}

export
default EntitlerController;



// WEBPACK FOOTER //
// ./app/components/entitler/entitler.controller.js